import React, { useCallback, useContext } from 'react';
import { style } from 'typestyle';
import OfficeIcon from 'mdi-react/DomainIcon';
import UserIcon from 'mdi-react/AccountSupervisorIcon';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import DashboardItemCard from './cards/dashboard-item-card.component';
import Column from '../../core/components/column/column.component';
import Row from '../../core/components/row/row.component';
import { IsMobileContext } from '../../core/context/is-mobile';
import RouteConstants from '../../core/routes.constants';
import CommonStyles from '../../core/common.styles';

const Dashboard = (): React.JSX.Element => {
  const navigate = useNavigate();
  const isMobile = useContext(IsMobileContext);
  const { t } = useTranslation();

  const navigateToOfficeDashboard = useCallback(() => {
    navigate(`/${RouteConstants.PATH_DASHBOARD}${RouteConstants.PATH_DASHBOARD_OFFICES}`);
  }, [navigate]);

  const navigateToUserDashboard = useCallback(() => {
    navigate(`/${RouteConstants.PATH_DASHBOARD}${RouteConstants.PATH_DASHBOARD_USERS}`);
  }, [navigate]);

  return (
    <div className={style(CommonStyles.pageMargin)}>
      <div className={style(CommonStyles.bodyMargin(isMobile))}>
        {isMobile ? (
          <Column itemSpacing={18}>
            <DashboardItemCard title={t('registered-offices')} onClick={navigateToOfficeDashboard} icon={OfficeIcon} />
            <DashboardItemCard title={t('administrator-accounts')} onClick={navigateToUserDashboard} icon={UserIcon} />
          </Column>
        ) : (
          <Row itemSpacing={50}>
            <DashboardItemCard title={t('registered-offices')} onClick={navigateToOfficeDashboard} icon={OfficeIcon} />
            <DashboardItemCard title={t('administrator-accounts')} onClick={navigateToUserDashboard} icon={UserIcon} />
          </Row>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
